<div
  class="mb-5 flex h-11 w-full flex-row items-center"
  *ngIf="reportSelectedNodes.length > 1"
>
  <div class="text-lg"> Multiple rows selected </div>

  <button
    type="button"
    data-cy="deleteRowsButton"
    class="border-s400 text-s500 hover:bg-m0 ml-7 flex flex-row items-center rounded border px-4 py-2 focus:outline-none"
    (click)="deleteRows()"
  >
    <m-trash-icon></m-trash-icon>
    <div class="ml-3"> Delete Rows </div>
  </button>
</div>

<div class="mb-5 flex h-full w-full flex-col" *ngIf="!!reportSelectedNode">
  <div class="flex flex-row items-start">
    <div class="flex h-11 flex-row items-center text-lg">
      <div class="text-s1 flex select-none items-center font-semibold">Row</div>

      <div class="ml-5 flex w-[26px] items-center">{{
        reportSelectedNode.data.rowId
      }}</div>

      <div class="ml-5 flex flex-row">
        <button
          type="button"
          data-cy="deleteRowButton"
          class="hover:bg-m200 text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
          (click)="deleteRows()"
        >
          <m-trash-icon></m-trash-icon>
        </button>
      </div>
    </div>

    <div class="ml-9 flex h-11 flex-row items-center space-x-5">
      <div class="text-s1 flex select-none items-center font-semibold"
        >Type</div
      >

      <div class="flex items-center">{{
        reportSelectedNode.data.rowType | capitalize
      }}</div>
    </div>

    <div
      class="ml-8 flex h-11 flex-row items-center"
      *ngIf="
        reportSelectedNode.data.rowType !== rowTypeEmpty &&
        reportSelectedNode.data.rowType !== rowTypeHeader
      "
    >
      <button
        type="button"
        data-cy="rowFormatButton"
        class="text-s500 hover:bg-m0 flex h-10 items-center justify-center rounded border px-5 text-base focus:outline-none"
        [ngClass]="{
          'border-p500 bg-m0 border-2': isShowFormatOptions === true,
          'border-s400': isShowFormatOptions === false
        }"
        (click)="toggleShowFormatOptions()"
      >
        Format #
      </button>
    </div>
  </div>

  <div class="divide-s300 ml-[20px] mr-[20px] mt-7 divide-y">
    <div></div>
    <div></div>
  </div>

  <div
    class="mt-7 flex flex-col"
    *ngIf="
      isShowFormatOptions === true &&
      (reportSelectedNode.data.rowType === rowTypeFormula ||
        reportSelectedNode.data.rowType === rowTypeMetric)
    "
  >
    <div class="flex h-11 flex-row items-start space-x-10">
      <div class="flex h-11 flex-row items-center space-x-5">
        <div
          class="text-s1 flex flex-shrink-0 select-none items-center font-semibold"
          >Format Number</div
        >

        <form [formGroup]="formatNumberForm" class="relative flex">
          <ng-select
            #formatNumberSelect
            [fixNgSelectBottom]="formatNumberSelect"
            data-cy="formatNumberSelect"
            class="format-number-select h-15 mr-5 w-[260px] text-base"
            [items]="formatNumberExamples"
            [clearable]="false"
            [searchable]="false"
            (change)="formatNumberBlur()"
            (keyup.esc)="
              $event.stopImmediatePropagation(); formatNumberSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation(); formatNumberSelect.blur()
            "
            appendTo="body"
            bindLabel="label"
            bindValue="id"
            formControlName="formatNumber"
          >
            <ng-template ng-label-tmp let-item="item">
              <m-format-number
                [inputItem]="item"
                [isOption]="false"
                class="ml-1 flex"
              ></m-format-number>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <m-format-number
                [inputItem]="item"
                [isOption]="true"
                class="ml-1 flex"
              ></m-format-number>
            </ng-template>
          </ng-select>

          <div class="relative">
            <input
              autocomplete="off"
              data-cy="formatNumberInput"
              class="form-input border-s3 focus:border-m600 w-[150px] resize-none rounded"
              [ngClass]="{
                'border-r600':
                  formatNumberForm.controls['formatNumber'].invalid &&
                  formatNumberForm.controls['formatNumber'].touched
              }"
              formControlName="formatNumber"
              placeholder=""
              (blur)="formatNumberBlur()"
            />
            <m-validation
              class="absolute -bottom-[22px] left-0"
              [control]="formatNumberForm.controls['formatNumber']"
            ></m-validation>
          </div>
        </form>
      </div>

      <div
        class="flex h-11 flex-row items-center space-x-5"
        *ngIf="
          !!formatNumberForm.controls['formatNumber'].value &&
          formatNumberForm.controls['formatNumber'].value?.indexOf('$') > -1
        "
      >
        <div
          class="text-s1 flex flex-shrink-0 select-none items-center font-semibold"
          >Currency Prefix</div
        >

        <div [formGroup]="currencyPrefixForm" class="relative flex w-[100px]">
          <input
            autocomplete="off"
            data-cy="currencyPrefixInput"
            class="form-input border-s3 focus:border-m600 w-full resize-none rounded"
            [ngClass]="{
              'border-r600':
                currencyPrefixForm.controls['currencyPrefix'].invalid &&
                currencyPrefixForm.controls['currencyPrefix'].touched
            }"
            formControlName="currencyPrefix"
            placeholder=""
            (blur)="currencyPrefixBlur()"
          />
          <m-validation
            class="absolute -bottom-[22px] left-0"
            [control]="currencyPrefixForm.controls['currencyPrefix']"
          ></m-validation>
        </div>
      </div>

      <div
        class="flex h-11 flex-row items-center space-x-5"
        *ngIf="
          !!formatNumberForm.controls['formatNumber'].value &&
          formatNumberForm.controls['formatNumber'].value?.indexOf('$') > -1
        "
      >
        <div
          class="text-s1 flex flex-shrink-0 select-none items-center font-semibold"
          >Currency Suffix</div
        >

        <div [formGroup]="currencySuffixForm" class="relative flex w-[100px]">
          <input
            autocomplete="off"
            data-cy="currencySuffixInput"
            class="form-input border-s3 focus:border-m600 w-full resize-none rounded"
            [ngClass]="{
              'border-r600':
                currencySuffixForm.controls['currencySuffix'].invalid &&
                currencySuffixForm.controls['currencySuffix'].touched
            }"
            formControlName="currencySuffix"
            placeholder=""
            (blur)="currencySuffixBlur()"
          />
          <m-validation
            class="absolute -bottom-[22px] left-0"
            [control]="currencySuffixForm.controls['currencySuffix']"
          ></m-validation>
        </div>
      </div>
    </div>

    <div class="divide-s300 ml-[20px] mr-[20px] mt-7 divide-y">
      <div></div>
      <div></div>
    </div>
  </div>

  <div
    *ngIf="
      reportSelectedNode.data.rowType !== rowTypeEmpty &&
      reportSelectedNode.data.rowType !== rowTypeMetric
    "
    class="mt-7 flex h-11 flex-row items-center space-x-5"
  >
    <div
      class="text-s1 flex flex-shrink-0 select-none items-center font-semibold"
      [ngClass]="{
        'w-[110px]': reportSelectedNode.data.rowType === rowTypeFormula,
        'w-[70px]': reportSelectedNode.data.rowType === rowTypeHeader
      }"
      >Name</div
    >

    <div
      [formGroup]="nameForm"
      class="relative flex w-full max-w-[550px] flex-1"
    >
      <input
        autocomplete="off"
        data-cy="nameInput"
        class="form-input border-s3 focus:border-m600 w-full min-w-[100px] resize-none rounded"
        [ngClass]="{
          'border-r600':
            nameForm.controls['name'].invalid &&
            nameForm.controls['name'].touched
        }"
        formControlName="name"
        placeholder=""
        (blur)="nameBlur()"
      />
      <m-validation
        class="absolute -bottom-[22px] left-0"
        [control]="nameForm.controls['name']"
      ></m-validation>
    </div>
  </div>

  <div
    *ngIf="reportSelectedNode.data.rowType === rowTypeFormula"
    class="mt-7 flex flex-1 flex-row items-start space-x-5"
  >
    <div
      class="text-s1 mt-3 flex w-[110px] flex-shrink-0 select-none items-center font-semibold"
      >Formula SQL</div
    >

    <div [formGroup]="formulaForm" class="relative flex max-w-[550px] flex-1">
      <textarea
        data-cy="formulaInput"
        class="form-input border-s3 focus:border-m600 placeholder-s400 max-h-[150px] min-h-[95px] w-full min-w-[300px] resize-y rounded font-mono"
        [ngClass]="{
          'border-r600':
            formulaForm.controls['formula'].invalid &&
            formulaForm.controls['formula'].touched
        }"
        formControlName="formula"
        placeholder="$A + $B"
        (blur)="formulaBlur()"
      ></textarea>
      <m-validation
        class="absolute -bottom-[22px] left-0"
        [control]="formulaForm.controls['formula']"
      ></m-validation>
    </div>
  </div>

  <div
    class="flex min-h-[44px] w-full flex-grow flex-row overflow-y-auto pt-7"
    *ngIf="reportSelectedNode.data.rowType === rowTypeMetric"
  >
    <div
      class="text-s1 flex h-11 select-none flex-row items-start space-x-2 font-semibold"
    >
      <div class="flex h-11 flex-row items-center space-x-2">
        <div class="truncate text-lg"> Parameters </div>
      </div>
    </div>

    <div class="flex w-full flex-col">
      <div class="flex w-full flex-row">
        <button
          type="button"
          data-cy="rowAddParameterButton"
          class="border-s400 text-s500 hover:bg-m0 ml-7 h-11 flex-shrink-0 select-none rounded border px-4 py-2 focus:outline-none"
          (click)="addParameter()"
        >
          Add Filter
        </button>

        <div class="min-h-[68px]"></div>

        <div class="ml-7 w-2 flex-1">
          <m-row-filters
            *ngIf="parametersFilters.length > 0"
            [reportSelectedNode]="reportSelectedNode"
            [mconfig]="mconfig"
            [report]="report"
            [parametersFilters]="parametersFilters"
          ></m-row-filters>
        </div>
      </div>
    </div>
  </div>

  <div class="divide-s300 ml-[20px] mr-[20px] divide-y">
    <div></div>
    <div></div>
  </div>
</div>

<div *ngIf="uiQuery$ | async"></div>
<div *ngIf="report$ | async"></div>
